import React from 'react'
import { LayoutBand, Separator } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import NotesCardSkeleton from '../person-page/cards/notes-card/NotesCardSkeleton'
import DiscussionsCardSkeleton from '../person-page/cards/discussions-card/DiscussionsCardSkeleton'
import { PersonBandSkeleton } from '../research-help/ResearchHelpPageSkeleton'

export default function NotesPageSkeleton(): JSX.Element {
  const hideDiscussions = useFeatureFlag('treeWebTx_personR9_hideDiscussions').isOn
  return (
    <>
      <PersonBandSkeleton />

      <LayoutBand maxWidth="lg" marginY="sm">
        <NotesCardSkeleton />
        {!hideDiscussions && (
          <>
            <Separator size="sm" />
            <DiscussionsCardSkeleton />
          </>
        )}
      </LayoutBand>
    </>
  )
}
